import templateMainRails from './../base/templates/ukrail/tabs.tmpl.html';
import templateMainTrainsRoundtrip from './../base/templates/ukrail/roundtrip.tmpl.html';
import templateMainTrainsOneway from './../base/templates/ukrail/oneway.tmpl.html';
import templateMainTrainsResults from './../base/templates/ukrail/results.tmpl.html';
import templateMainTrainsEuropeanResults from './../base/templates/ukrail/europeanresults.tmpl.html';
import templateMainTrainsHeader from './../base/templates/ukrail/results_header.tmpl.html';
import ukRailsSearchFormCtrl from './controllers/ukrailSearchFormCtrl';
import UkrailResultController from './controllers/ukrailResultCtrl';
import EuropeanRailsResultController from './controllers/europeanRailsResultCtrl';
import UkrailRoundtripController from './controllers/ukrailRoundtripCtrl';
import UkrailOnewayController from './controllers/ukrailOnewayCtrl';
import UkrailHeaderController from './controllers/ukrailHeaderCtrl';
import RulesBaseController from '../base/controllers/flights/rulesBaseCtrl';

export const railStates = {
    MAIN: 'main.ukrail',
    ROUNDTRIP: 'main.ukrail.roundtrip',
    ONEWAY: 'main.ukrail.oneway',
    RESULTS: 'main.ukrail.results',
    EUROPEANRESULTS: 'main.ukrail.europeanresults',
    EUROPEANRESULTSINWARD: 'main.ukrail.europeanresults.inward',
    RULES: 'main.ukrail.results.rules',
};

export default function RailRoutes(
    $stateProvider,
    $urlRouterProvider
) {
    'ngInject';
    $urlRouterProvider.when('/search/ukrail', '/search/ukrail/roundtrip');
    $stateProvider // eslint-disable-line
        .state(railStates.MAIN, {
            url: '/ukrail',
            views: {
                '': {
                    template: templateMainRails,
                    controller: ukRailsSearchFormCtrl,
                    controllerAs: 'ukRailSearchFormCtrl',
                    resolve: {
                        timeSlots: function(staticDataGetter) {
                            'ngInject';
                            return staticDataGetter.getTimeSlots();
                        },
                        staticData: (railsService) => {
                            return railsService.getStaticData();
                        },
                    },
                },
            },
            resolve: {
                railsFactory: (rtFactory) => {
                    'ngInject';
                    return new rtFactory('ukrail'); // eslint-disable-line
                },
            },
            onEnter: ['$rootScope', function($rootScope) {
                'ngInject';
                $rootScope.pageHeading = 'Rail search';
            }],
            params: {DomesticSearchGUId: '0', FlightType: 'null', rebook: null},
        })
        .state(railStates.ROUNDTRIP, {
            url: '/roundtrip',
            template: templateMainTrainsRoundtrip,
            controller: UkrailRoundtripController,
            params: {DomesticSearchGUId: '0', FlightType: 'null'},
        })
        .state(railStates.ONEWAY, {
            url: '/oneway',
            template: templateMainTrainsOneway,
            controller: UkrailOnewayController,
        })

        .state(railStates.RESULTS, {
            url: '/results',
            params: {rebook: null},
            views: {
                '@main': {
                    template: templateMainTrainsResults,
                    controller: UkrailResultController,
                    controllerAs: 'ukrailResultCtrl',
                },
                [`page_title@${railStates.RESULTS}`]: {
                    template: templateMainTrainsHeader,
                    controller: UkrailHeaderController,
                },
            },
        })
        .state(railStates.EUROPEANRESULTS, {
            url: '/europeanresults',
            params: {rebook: null},
            views: {
                '@main': {
                    template: templateMainTrainsEuropeanResults,
                    controller: EuropeanRailsResultController,
                    controllerAs: 'ukrailResultCtrl',
                },
                [`page_title@${railStates.EUROPEANRESULTS}`]: {
                    template: templateMainTrainsHeader,
                    controller: UkrailHeaderController,
                },
            },
        })
        .state(railStates.EUROPEANRESULTSINWARD, {
            url: '/inward',
            params: {outwardSelection: null},
            views: {
                '@main': {
                    template: templateMainTrainsEuropeanResults,
                    controller: EuropeanRailsResultController,
                    controllerAs: 'ukrailResultCtrl',
                },
                [`page_title@${railStates.EUROPEANRESULTSINWARD}`]: {
                    template: templateMainTrainsHeader,
                    controller: UkrailHeaderController,
                },
            },
        })
        .state(railStates.RULES, {
            url: '/rules?fare&recommendation&adult&child&infant&search&groups&anchor&culture',
            resolve: {
                anchorLink: ['$stateParams', function($stateParams) {
                    'ngInject';
                    return $stateParams.anchor;
                }],
                rules: ['$stateParams', 'railsFactory', function($stateParams, flightsFactory) {
                    'ngInject';
                    return flightsFactory.getRules({
                        searchId: $stateParams.search,
                        fareId: $stateParams.fare,
                        recommendationId: $stateParams.recommendation,
                        adultCount: $stateParams.adult,
                        childCount: $stateParams.child,
                        infantCount: $stateParams.infant,
                        flightGroups: $stateParams.groups,
                        culture: $stateParams.culture,
                    });
                }],
            },
            views: {
                '@main': {
                    templateUrl: './../base/templates/ukrail/rules.tmpl.html',
                    controller: RulesBaseController,
                },
            },
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/ukrail-routes.js